import { getTemplateContent } from '@shared/ui/elements/getTemplateContent';
import { consoleLogger } from '@shared/logging/consoleLogger';

export const isUtiqInfoPage = async () => {
  const templateData = await getTemplateContent();
  const utiqInfoPagesURLs = [
    templateData?.listOfAttributes?.privacyStatementUrl,
    templateData?.listOfAttributes?.manageUtiqPageWebsiteListUrl,
    templateData?.manageUtiqPageUrl, // legacy
    templateData?.listOfPrivacyPolicyKeywords?.manageUtiqPageUrl, // legacy
  ];

  const isInfoPage = utiqInfoPagesURLs.some((utiqInfoPageUrl) => {
    if (utiqInfoPageUrl) {
      if (typeof utiqInfoPageUrl !== 'string') {
        throw new Error(`utiqInfoPageUrl is not a string ${utiqInfoPageUrl}`);
      }
      const utiqPageUrl = new URL(utiqInfoPageUrl);

      // Split site pathname for removing '.html' part if found
      const [utiqInfoPagePath] = utiqPageUrl.pathname.split('.');

      return utiqInfoPagePath !== '/'
        ? window.location.href.includes(utiqInfoPagePath)
        : window.location.href === utiqInfoPageUrl;
    }
    return false;
  });
  if (isInfoPage) {
    consoleLogger.logDebug(
      'Consent manager will not be shown for the current Utiq informational page.',
    );
  }
  return isInfoPage;
};
